import * as React from "react";
const SvgIcCalendarFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M5 1H8V3H16V1H19V3H23V8H1V3H5V1ZM23 10H1V23H23V10Z" fill="currentColor" /></svg>;
export default SvgIcCalendarFilled;